export default __webpack_public_path__ + "images/0dac45e92d3d7c342ffc51daf7656606.png";